import { render, staticRenderFns } from "./TheExtra.vue?vue&type=template&id=aa44c1d8&"
import script from "./TheExtra.vue?vue&type=script&lang=js&"
export * from "./TheExtra.vue?vue&type=script&lang=js&"
import style0 from "./TheExtra.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports